document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('[data-crossfade-slideshow]').forEach(container => {
		const slides = [...container.querySelectorAll('[data-slide]')];
		if (slides.length < 2) return;

		slides.forEach((slide, i) => {
			slide.style.transition = 'opacity 600ms ease-in-out';
			slide.style.opacity = i === 0 ? '1' : '0';
		});

		let current = 0;

		setInterval(() => {
			slides[current].style.opacity = '0';
			current = (current + 1) % slides.length;
			slides[current].style.opacity = '1';
		}, 3000);
	});
});
